const INTERACTIVE_SEL =
  'button,a,input,select,textarea,summary,label,[role="button"],[role="link"],[role="tab"],[role="menuitem"],[role="switch"],[role="checkbox"],[data-analytics]';

const TEXT_MAX = 48;

/**
 * @param {EventTarget | null} target
 * @returns {Element | null}
 */
function asElement(target) {
  if (!target || typeof target !== 'object') return null;
  if (target.nodeType === 1) return /** @type {Element} */ (target);
  if (target.nodeType === 3 && target.parentElement) return target.parentElement;
  return null;
}

/**
 * @param {Element} el
 * @returns {string}
 */
function readLabel(el) {
  const analytics = el.getAttribute('data-analytics');
  if (analytics) return analytics.trim().slice(0, TEXT_MAX);

  const testId = el.getAttribute('data-testid') || el.getAttribute('data-test');
  if (testId) return testId.trim().slice(0, TEXT_MAX);

  const aria = el.getAttribute('aria-label');
  if (aria) return aria.trim().slice(0, TEXT_MAX);

  const title = el.getAttribute('title');
  if (title) return title.trim().slice(0, TEXT_MAX);

  const alt = el.getAttribute('alt');
  if (alt) return alt.trim().slice(0, TEXT_MAX);

  const name = el.getAttribute('name');
  if (name) return name.trim().slice(0, TEXT_MAX);

  const id = el.id;
  if (id && id.length <= 40 && !/^[a-f0-9-]{20,}$/i.test(id)) {
    return `#${id}`.slice(0, TEXT_MAX);
  }

  const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
  if (text) return text.slice(0, TEXT_MAX);

  return '';
}

/**
 * 从点击目标解析一条可入库的描述（不含输入值）。
 * @param {EventTarget | null} target
 * @returns {null | {
 *   tag: string,
 *   role?: string,
 *   type?: string,
 *   label?: string,
 *   href?: string,
 * }}
 */
export function resolveAnalyticsClickTarget(target) {
  const start = asElement(target);
  if (!start || typeof start.closest !== 'function') return null;

  const el = start.closest(INTERACTIVE_SEL) || start;
  if (!el || el === document.documentElement || el === document.body) {
    return {
      tag: (start.tagName || 'unknown').toLowerCase(),
      label: readLabel(start) || undefined,
    };
  }

  const tag = (el.tagName || 'unknown').toLowerCase();
  const role = el.getAttribute('role') || undefined;
  const typeAttr = el.getAttribute('type');
  const type = typeAttr ? typeAttr.toLowerCase() : undefined;

  /** @type {{ tag: string, role?: string, type?: string, label?: string, href?: string }} */
  const info = { tag };
  if (role) info.role = role;
  if (type) info.type = type;

  const label = readLabel(el);
  if (label) info.label = label;

  if (tag === 'a') {
    const href = el.getAttribute('href');
    if (href && !href.toLowerCase().startsWith('javascript:')) {
      info.href = href.trim().slice(0, 120);
    }
  }

  return info;
}
